import SiteConfig from '@/services/SiteConfig'

export const COLLECTION_PAGE_API_URL =
  SiteConfig.apiRoot + 'v2/collection-page-sites/'

export const ASSET_DOWNLOAD_URL = SiteConfig.apiRoot + 'v2/assets/'

export const COLLECTION_ROUTE_NAME = 'collection'
